
seedWebApp.controller('RoutesController', ['$scope', '$rootScope', 'ContactService', '$uibModal', 'ToastService', 'TranslationService', 'StoreService',
    function ($scope, $rootScope, ContactService, $uibModal, ToastService, TranslationService, StoreService) {

    $scope.translation = TranslationService.getActiveTranslation();
    $scope.prefs = {
        name: 'RoutesGrid',
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,        
    };

    
    $scope.columns = [
        { name: 'RouteID', display: 'ID', orderBy: 'asc', editable: false, width: 5, isKey: true },  //filterOptions: [] 
        { name: 'RouteName', display: 'Itinerário', editable: true, width: 25 },
        { name: 'ShippingPoint', display: 'Pto Despacho', editable: true, width: 5 },
        { name: 'BoardingPoint', display: 'Pto Enbarque', editable: true, width: 5 },
        { name: 'LandingPoint', display: 'Pto Desembarque', editable: true, width: 5 },
        { name: 'ArrivalPoint', display: 'Pto Chegada', editable: true, width: 5 },
        { name: 'RouteDistance', display: 'Distância', editable: true, width: 5 },
        { name: 'RouteDays', display: 'Dias', editable: true, width: 15 },
    ];


    //$scope.prefs.sortByCol = $scope.columns[0];
    //$scope.prefs.sortByCol.orderReverse = false;
        
    $scope.loadService = ContactService.getRoutes;
    $scope.resetService = ContactService.resetCache;
    //$scope.loadColumns = ContactService.getContactsColumns;

    $scope.getTotal = function () {
        $scope.loadingTotal = true;
        ContactService.getRoutesCount().then(function (response) {
            $scope.loadingTotal = false;
            if (response) {
                $scope.totalItems = response.data.TotalCount;
                $scope.lastSync = response.data.LastSync;
            }

        });
    };

    $scope.getTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'rotas');
    };

    $scope.doInsert = function () {
        $scope.$broadcast('addItem');
    };
    
    //$(document).ready(function () {
    //    $scope.overflowSize = $scope.AdjustSize();
    //});

}]);
